import { MAX_DISTANCE } from './constants';
import { distanceUnit } from './transform';

const facetObj = (key, value, name = null, numbers = false) => ({
  children: [],
  name: decodeURIComponent(name || value),
  queryStringId: `${key}=${numbers ? value : encodeURIComponent(value)}`,
  queryAs: numbers ? value : encodeURIComponent(value),
});

export const createFacet = (searchDetails, { country }) => {
  const facets = [];
  const detailsObj = Object.entries(searchDetails);

  detailsObj.map((items) => {
    const [key, value] = items;

    switch (key) {
      case 'frequency':
      case 'dontFacetKeyword':
      case 'sort':
      case 'point':
      case 'locations':
        break;

      case 'excludedLocations': {
        if (Array.isArray(value)) {
          value.map((item) => facets.push(facetObj(key, item, `NOT ${item}`)));
        } else {
          facets.push(facetObj(key, value, `NOT ${value}`));
        }

        break;
      }

      case 'applicationType': {
        const name = `Quick Apply`;
        facets.push(facetObj(key, value, name));

        break;
      }

      case 'ageRange': {
        const [min, max] = value.split(',');
        const name = `From ${min} to ${max} years old`;

        facets.push(facetObj(key, value, name, true));
        break;
      }

      case 'maxdistance': {
        const [distanceValue] = MAX_DISTANCE.filter((distance) => distance.id === value);
        const name = `Radius ${distanceValue.name} ${distanceUnit(country)}`;

        facets.push(facetObj(key, value, name));
        break;
      }

      case 'displayLocation': {
        const { point, locations } = searchDetails;

        const params = [`displayLocation=${encodeURIComponent(value)}`];

        if (locations) {
          params.push(`locations=${encodeURIComponent(locations)}`);
        }

        if (point) {
          params.push(`point=${encodeURIComponent(point)}`);
        }

        facets.push({
          name: decodeURIComponent(value),
          queryStringId: params.join('&'),
          queryAs: encodeURIComponent(value),
        });
        break;
      }

      default: {
        if (Array.isArray(value)) {
          value.map((item) => facets.push(facetObj(key, item)));
        } else {
          facets.push(facetObj(key, value));
        }

        break;
      }
    }

    return facets;
  });

  return facets;
};
